export default "__VITE_ASSET__9cb72913__"